module.exports = __webpack_public_path__ + "img/LA.a8b72420.png";